import React, { useRef } from 'react';
import { useForm } from 'react-hook-form';
import YFinput from '../elements/YFInput';
import { useApiCall } from '../../api/apiCallHook';
import { submitResetPassword } from '../../api';
import { Row, Col, Modal } from 'antd';
import Loading from '../../components/Loading';
import { useLocation, useHistory } from 'react-router-dom';

const ResetPasswordForm = () => {
    const { handleSubmit, register, errors, watch } = useForm();
    const password = useRef({});
    password.current = watch('password', '');
    const location = useLocation();
    const history = useHistory();
    const query = new URLSearchParams(location.search);
    const email = query.get('email');
    const { execute, pending, value, error } = useApiCall(submitResetPassword, false);

    const onSubmit = (value) => {
        value.token = query.get('token');
        execute({ request: value });
    };

    if (value) {
        Modal.confirm({
            title: value.message,
            content: 'Please sign in with new password',
            onOk: () => {
                history.push('/');
                window.location.reload(false);
            },
        });
    }

    return (
        <form className="solutionForBusinessFormContainer" onSubmit={handleSubmit(onSubmit)}>
            <Row>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                    className="horizontal-container-element"
                >
                    <YFinput
                        name="email"
                        type="text"
                        label="Email"
                        placeholder="Enter Email"
                        defaultValue={email}
                        register={register({
                            required: 'Please enter your email',
                            pattern: {
                                value: /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                message: 'Invalid email address',
                            },
                        })}
                    />
                    {errors.email && <p className="formFieldError">{errors.email.message}</p>}
                    {error !== null && <p className="formFieldError">{error.errors.email[0]}</p>}
                </Col>
            </Row>

            <Row>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                    className="horizontal-container-element"
                >
                    <YFinput
                        name="password"
                        type="password"
                        label="Password"
                        placeholder="Enter Password"
                        register={register({
                            required: 'You must specify a password',
                            minLength: {
                                value: 8,
                                message: 'Password must have at least 8 characters',
                            },
                        })}
                    />
                    {errors.password && <p className="formFieldError">{errors.password.message}</p>}
                </Col>
            </Row>
            <Row>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                    className="horizontal-container-element"
                >
                    <YFinput
                        name="password_confirmation"
                        type="password"
                        label="Confirm Password"
                        placeholder="Enter Confirm Password"
                        register={register({
                            validate: (value) => value === password.current || 'The passwords do not match',
                        })}
                    />
                    {errors.password_confirmation && (
                        <p className="formFieldError">{errors.password_confirmation.message}</p>
                    )}
                </Col>
            </Row>

            <>{pending ? <Loading /> : <input type="submit" label="Submit" />}</>
        </form>
    );
};

export default ResetPasswordForm;
